import { MembershipViewModel } from "../../../viewModels";

export default function MembershipList({memberships}:{memberships:MembershipViewModel[]}){
    return  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {memberships.map((membership) => (
                    <div key={membership.id} className="bg-white rounded-lg shadow-lg p-8 flex flex-col justify-between border border-blue-200 hover:border-blue-500 transition-all duration-300">
                        <div>
                            <h2 className="text-3xl font-bold text-purple-700 mb-4">{membership.title}</h2>
                            <p className="text-gray-600 mb-6">{membership.description}</p>
                            <div className="text-4xl font-extrabold text-purple-900 mb-6">
                                ${membership.price}
                                <span className="text-xl font-medium text-gray-500">/{membership.duration === 365 ? 'year' : membership.duration === 30 ? 'month' : `${membership.duration} days`}</span>
                            </div>
                            <ul className="text-gray-700 space-y-3 mb-8">
                                {membership.features?.map((feature, index) => (
                                    <li key={index} className="flex items-center">
                                        <svg className="w-5 h-5 text-purple-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        {feature.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <button className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-300">
                            Choose Plan
                        </button>
                    </div>
                ))}
            </div>
}